module.exports = __webpack_public_path__ + "img/import_done_shadow.43953de.png";